<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_vi"></a><a id="ch00_fm05"></a>Copyright © 2001 Jimmy Santiago Baca</p>
<p class="noindentfm">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, or the facilitation thereof, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="noindentfm">Special thanks go to Anton Mueller for his effort in making this book a reality.<br/>Names have been changed to protect the privacy of certain individuals.</p>
<p class="noindentfm"><em>Published simultaneously in Canada<br/>Printed in the United States of America</em></p>
<p class="noindentfm">Library of Congress Cataloging-in-Publication Data</p>
<p class="noindentfm">Baca, Jimmy Santiago, 1952–</p>
<p class="indentfm">A place to stand: the making of a poet / Jimmy Santiago Baca.</p>
<p class="indentfm1">p. cm.</p>
<p class="indentfm">ISBN-10: 0-8021-3908-6</p>
<p class="indentfm">ISBN-13: 978-0-8021-3908-5</p>
<p class="indentfm">1. Baca, Jimmy Santiago, 1952– 2. Poets, American—20th century—Biography. 3. Ex-convicts—United States—Biography. 4. Solitary confinement—United States. 5. Mexican American poets—Biography. 6. Prisons—United States. I. Title.</p>
<p class="indent"> </p>
<p class="indentfm3">PS3552.A254 Z473 2001</p>
<p class="indentfm3">811’.54—dc21</p>
<p class="indentfm3">[B]</p>
<p class="textright">00-051400</p>
<p class="noindent"><span class="small">DESIGN BY LAURA HAMMOND HOUGH</span></p>
<p class="noindentfm">Grove Press</p>
<p class="noindent">an imprint of Grove/Atlantic, Inc.</p>
<p class="noindent">841 Broadway</p>
<p class="noindent">New York, NY 10003</p>
<p class="noindentfm">Distributed by Publishers Group West</p>
<p class="noindentfm"><span class="weblink"><a class="nounder" href="http://www.groveatlantic.com" target="_blank">www.groveatlantic.com</a></span></p>
<p class="noindentfm">09 10 11 12      15 14 13 12 11</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?6ffda1b0